export const MARGIN_CHART = { top: 16, right: 16, bottom: 16, left: 16 }
export const HEIGHT_XAXIS = 30
export const TICK_MARGIN_XAXIS = 15
export const TICK_MARGIN_YAXIS = 8

export const AXIS_LABEL_POSITION = {
  TOP_RIGHT: 'TOP_RIGHT',
  TOP_LEFT: 'TOP_LEFT',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  BOTTOM: 'BOTTOM',
}
